import React, { useEffect, useState } from "react";
import crmservices from '../../wsclient';
import LoadingComponent from "../../components/Loading";
import AlertComponent from "../../components/Alert";
import { useTranslation } from "react-i18next";
import ServiceRequestDetailView from "./ServiceRequestDetailView";
import { getData } from "../../utils/common";
import { connection } from "../../portal.config";

const PAGE_SIZE = 10;

export default function ServiceRequestDetailController(props) {
const { t } = useTranslation();
    const { serviceRequest} = props;
    const [showLoading, setShowLoading] = useState(false);
    const [files, setFiles] = useState([]);
    const [newFiles, setNewFiles] = useState([]);
    const [message, setMessage] = useState(null);
    const [showProcessing, setShowProcessing] = useState(false);
    const [showLoadMoreServiceRequests, setShowLoadSericeRequests] = useState(false);
    const [filesUpload, setFilesUpload] = useState([]);
    const [addAttachment, setAddAttachment] = useState(false);
    
    const [serviceRequestNotes, setServiceRequestNotes] = useState({
            content: [],
            paging: {
                page: 1,
                size: PAGE_SIZE,
                total: 0,
                has_more: false
            }
        });;

    useEffect(() => { 
        if (serviceRequest) {
            onLoadServiceRequestNotes(serviceRequest.id);
            onLoadFiles(serviceRequest.id);
        }
    }, [])

    const onLoadFiles = async (serviceRequestId) => {
        try {
            var result = await crmservices.servicerequest.getListServiceRequestAttachment({}, serviceRequestId);
            if (result.code == 'OK' && result.data && result.data.content && result.data.content.length > 0) {
                let _files = [];
                _files.push({ sr_id: serviceRequestId, files: result.data.content.length > 0 ? result.data.content : [] })
                setFiles(_files);
            }
        } catch (error) {}
    }


    const onSubmitAddNote = async (note, serviceRequestId) => {
        try {
            var result = await crmservices.servicerequest.createServiceRequestNote({
                note: note,
                service_request_id: serviceRequestId,
            });
            if (result.code == 'OK') {
                onLoadServiceRequestNotes(serviceRequestId);
            }
        } catch (error) {
            console.log('SRController error:', error)
        }
    }

    const showMessage = ({ status, title, message, otherMessage, callBackFn }) => {
        setShowLoading(false);
        setMessage({ show: status, title: title, content: message, otherMessage, callBackFn: callBackFn ? callBackFn : () => setMessage({}) });
    }

    const onLoadServiceRequestNotes = async (serviceRequestId) => {
        setShowProcessing(true)
        try {
            const result = await crmservices.servicerequest.getListServiceRequestNotes({
                include_total: true,
                page: 1,
                size: PAGE_SIZE}, serviceRequestId);
            if (result.code == 'OK') {
                let notes = result.data.content.length > 0 ? result.data.content : [];
                //set showAllDesc to false for all result.data.content
                for (let i = 0; i < notes.length; i++) {
                    notes[i].showAllNote = false;
                }

                setServiceRequestNotes({
                    content: notes,
                    paging: result.data.paging
                });
            }
        } catch (error) {
            console.log('onLoadServiceRequestNoted exception error:', error)
        }
        setShowProcessing(false)
    }

    const onShowAllNote = (note) => {
        let _serviceRequestNotes = serviceRequestNotes.content.map((itemNote) => {
            if(itemNote.id === note.id){
                return {
                    ...itemNote,
                    showAllNote: !itemNote.showAllNote
                }
            }
            return itemNote;
        })
        setServiceRequestNotes({
            content: _serviceRequestNotes,
            paging: serviceRequestNotes.paging
        });
    }

    const handleLoadMore = async () => {
        try {
            setShowLoadSericeRequests(true);
            let _serviceRequestNotes = serviceRequestNotes ? [...serviceRequestNotes.content] : [];
            var page = serviceRequestNotes.paging && serviceRequestNotes.paging.page ? serviceRequestNotes.paging.page + 1 : 0;
                var result = await crmservices.servicerequest.getListServiceRequestNotes({
                    page: page,
                    size: PAGE_SIZE}, serviceRequest.id);
                if (result.code === 'OK') {
                    if (result.data && result.data.content && result.data.content.length > 0) {
                      
                        let _paging = result.data && result.data.paging ? result.data.paging : {
                            total: 0,
                            size: PAGE_SIZE,
                            page: 1,
                        };
                        _serviceRequestNotes = [..._serviceRequestNotes, ...result.data.content];
                        setServiceRequestNotes({
                            content:_serviceRequestNotes,paging:_paging});
                    }
                }
                setShowLoadSericeRequests(false);
                // }
            } catch (error) {
                setShowLoadSericeRequests(false);
            }
        }

    const get_url_extension = (url) => {
        return url.split(/[#?]/)[0].split('.').pop().trim();
    }

    const onOpenFile = async (file) => {
        setShowLoading(true);
        try {
            if (file) {
                let extention = get_url_extension(file.name);
                const accessToken = await getData('crmcom_access_token')
                var url = connection.crmConfig.crmServer + '/self-service/v2/files/' + file.id;
                let result = await fetch(url, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        method: 'GET',
                    }
                });
                let resultBlob = await result.blob();
                window.open(window.URL.createObjectURL(resultBlob))
            }
        } catch (error) {}
        setShowLoading(false);
    }

    const onSaveFilesState = async () => {
        if(filesUpload && filesUpload.length > 0 ) setNewFiles(filesUpload);
        setAddAttachment(false);
        let fileUploaded = await onUploadFile();
        if (fileUploaded.length > 0) {
            await onAddSRAttachment(serviceRequest.id, fileUploaded);
        }
    }

    const removeFile = (file) => {
        let _files = filesUpload.filter(f => f.id !== file.id);
        setFilesUpload(_files);
        setNewFiles(_files);
    }


    const onDeleteFile = async (file) => {
        try {
            let result = await crmservices.servicerequest.deleteServiceRequestAttachment({
                service_request_id: serviceRequest.id,
                file_id: file.id
            });
            onLoadFiles(serviceRequest.id);
            
        } catch (error) {
            console.log("onDeleteFile exception:", error);
        }
        const filesExist = files.filter(f=>f.id !== file.id);
        setFiles(filesExist);
    }

    const onAddSRAttachment = async (service_request_id, filesUploaded) => {
        setShowProcessing(true);
        try {
            for (let i = 0; i < filesUploaded.length; i++) {
                let result = await crmservices.servicerequest.addServiceRequestAttachment({
                    service_request_id: service_request_id,
                    file_id: filesUploaded[i]
                });
            }
            setFilesUpload([]);
            setNewFiles([]);
        } catch (error) {
            console.log("onAddSRAttachment exception:", error);
        }
        await onLoadFiles(service_request_id);
        setShowProcessing(false);
    }

    const onUploadFile = async () => {
        let _filesUploaded = [];
        try {
            if (filesUpload.length > 0) {
                for (let i = 0; i < filesUpload.length; i++) {
                    const result = await crmservices.servicerequest.uploadFiles({ file: filesUpload[i], disalbedContentType: true });
                    if (result.code == 'OK' && result.data.id) {
                        _filesUploaded.push(result.data.id);
                    }
                }
            }
        } catch (error) {
            console.log("onUploadFile exception:", error);
        }
        return _filesUploaded
    }

    const uploadFiles = (files) => {
        if(files.length > 3){
            showMessage({ status: true, message: t('error_max_files')})
            return false;
        }
        else{
            setFilesUpload(files);
        }
    }

    const onCapture = async (photo) => {
        let f = filesUpload ? [...filesUpload] : [];
        f.push(photo);
        uploadFiles(f);
        setNewFiles(f);
    }

    return (
        <>
            <ServiceRequestDetailView
                serviceRequest={serviceRequest}
                showProcessing={showProcessing}
                open={props.open}
                onClose={props.onClose}
                serviceRequestNotes={serviceRequestNotes}
                files={files}
                onOpenFile={onOpenFile}
                onSubmitAddNote={onSubmitAddNote}
                onLoadServiceRequestNotes={onLoadServiceRequestNotes}
                showLoadMoreServiceRequests={showLoadMoreServiceRequests}
                handleLoadMore={handleLoadMore}
                onSaveFilesState={onSaveFilesState}
                onUploadFile={onUploadFile}
                uploadFiles={uploadFiles}
                newFiles={newFiles}
                addAttachment={addAttachment}
                setAddAttachment={setAddAttachment}
                onCapture={onCapture}
                onShowAllNote={onShowAllNote}
                onDeleteFile={onDeleteFile}
                removeFile={removeFile}
            />
            {showProcessing && <LoadingComponent showLoading={showProcessing}/>}
            {message && message.show && <AlertComponent
                isOpen={message.show}
                message={message.content}
                otherMessage={message.otherMessage ? message.otherMessage : null}
                onClose={message.callBackFn}
            />}
        </>
    )
}